"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatMessageInterpolator = void 0;

var _intlMessageformat = _interopRequireDefault(require("intl-messageformat"));

var _intlFormatCache = _interopRequireDefault(require("intl-format-cache"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var formatMessageInterpolator = function formatMessageInterpolator(message, values, locale, formats) {
  var formattedMessage;

  try {
    var formatter = (0, _intlFormatCache["default"])(_intlMessageformat["default"]);
    formattedMessage = formatter(message, locale, formats).format(values);
  } catch (error) {
    console.error("Failed to format message: \"".concat(message, "\" of locale: \"").concat(locale, "\"\n").concat(error));
  }

  return formattedMessage || message;
};

exports.formatMessageInterpolator = formatMessageInterpolator;
//# sourceMappingURL=FormatMessageInterpolator.js.map